export default __webpack_public_path__ + "static/media/Rule17.b2787bad.png";